/** @param {string} lang i18n.language (e.g. ru, en-US) */
export function getLocalizedCategoryTitle(category, lang, emptyFallback = '') {
  if (!category) return emptyFallback;
  const l = (lang || '').split('-')[0].toLowerCase();
  if (l === 'ru') {
    return category.titleRu || category.title || category.titleEn || emptyFallback;
  }
  if (l === 'en') {
    return category.titleEn || category.title || category.titleRu || emptyFallback;
  }
  if (l === 'ro') {
    return category.title || category.titleRu || category.titleEn || emptyFallback;
  }
  return category.titleEn || category.titleRu || category.title || emptyFallback;
}

export function getCategoryRowId(c) {
  if (!c) return '';
  return String(c.categoryId ?? c.id ?? '').trim();
}

/** Lowercase string for search across all title fields */
export function getCategorySearchHaystack(c) {
  if (!c) return '';
  return [c.title, c.titleRu, c.titleEn]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}
